var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 119.833,
    viewBox: "0 0 123 119.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-884.936 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(884.936 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M288.512,231.282,298.2,221.5c-.521-.585-1.07-1.265-1.684-1.88q-26.381-26.387-52.737-52.8a5.043,5.043,0,0,1-1.307-3.007c-.177-2.867-.061-5.752-.061-9.261,4.4,4.453,8.38,8.516,12.4,12.54q23.518,23.54,47.057,47.059c2,2,2,2,3.961.041q28.876-28.863,57.746-57.731c.474-.474.866-1.03,1.3-1.547l.486.253c0,3.138.054,6.277-.043,9.412a3.231,3.231,0,0,1-.937,1.953Q350.229,180.7,336.015,194.8c-8.339,8.318-16.622,16.693-25,24.968-1.377,1.36-1.566,2.167-.052,3.586,2.653,2.487,5.07,5.228,7.566,7.842l46.116-46.16.656.379c0,3.268.054,6.537-.051,9.8-.018.569-.623,1.2-1.09,1.665q-19.781,19.833-39.625,39.6a7.468,7.468,0,0,1-2.516,1.079c-.119.047-.276-.015-.411.007a11.611,11.611,0,0,1-12.143-4.917c-1.206-1.645-2.971-2.867-4.363-4.39-.957-1.048-1.7-.872-2.563.012-2.266,2.309-4.6,4.55-6.8,6.922a7.693,7.693,0,0,1-5.512,2.532c-4.43.381-7.354-1.32-10.361-4.414-11.815-12.152-23.89-24.052-35.912-36a4.682,4.682,0,0,1-1.572-3.805c.11-2.667.03-5.342.03-8.522Z",
    transform: "translate(-242.375 -154.555)",
    fill: "#b58156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M411.478,243.827c0,1.558,0,3.181,0,4.8q0,7.529,0,15.059c0,.951.006,1.818-1.329,1.815-6.854-.014-13.708-.007-20.362-.007Z",
    transform: "translate(-288.52 -182.501)",
    fill: "#b58156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M263.856,265.485c-6.361,0-13.17.022-19.979-.047-.476,0-1.353-.675-1.357-1.044-.082-6.857-.06-13.714-.06-20.618Z",
    transform: "translate(-242.401 -182.485)",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(886.49 111.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M258.263,288.162h.164v13.7h-1.38a1.1,1.1,0,0,1-1.243-1.234v-5.693l-4.276,5.145-4.268-5.145v5.693a1.1,1.1,0,0,1-1.243,1.234h-1.38v-13.7h.164l6.727,7.914Z",
    transform: "translate(-244.637 -287.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M275.181,302a6.785,6.785,0,0,1-5.118-2.051,7.474,7.474,0,0,1,0-10.12,7.424,7.424,0,0,1,10.254,0,7.478,7.478,0,0,1,0,10.125A6.806,6.806,0,0,1,275.181,302Zm3.185-10.44a4.453,4.453,0,0,0-6.365,0,4.892,4.892,0,0,0,0,6.657,4.44,4.44,0,0,0,6.365,0,4.88,4.88,0,0,0,0-6.657Z",
    transform: "translate(-251.979 -287.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M298.221,302a6.785,6.785,0,0,1-5.118-2.051,7.474,7.474,0,0,1,0-10.12,7.424,7.424,0,0,1,10.254,0,7.478,7.478,0,0,1,0,10.125A6.8,6.8,0,0,1,298.221,302Zm3.185-10.44a4.453,4.453,0,0,0-6.365,0,4.892,4.892,0,0,0,0,6.657,4.44,4.44,0,0,0,6.365,0,4.88,4.88,0,0,0,0-6.657Z",
    transform: "translate(-259.191 -287.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M327.08,301.861h-.274l-9.02-8.143v6.909a1.1,1.1,0,0,1-1.243,1.234h-1.362v-13.7h.283l9,8.289V289.4a1.091,1.091,0,0,1,1.234-1.234h1.38Z",
    transform: "translate(-266.72 -287.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M339.488,299.539h6a1.09,1.09,0,0,1,1.234,1.234v1.087h-9.86v-13.7h1.38a1.1,1.1,0,0,1,1.243,1.234Z",
    transform: "translate(-273.508 -287.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M355.268,288.162A1.091,1.091,0,0,1,356.5,289.4v12.465h-1.389a1.091,1.091,0,0,1-1.234-1.234V288.162Z",
    transform: "translate(-278.834 -287.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M375.217,294.264a13.9,13.9,0,0,1,0,1.754,6.356,6.356,0,0,1-2.061,4.327,6.649,6.649,0,0,1-4.656,1.667,7.064,7.064,0,0,1-5.159-2.079,6.792,6.792,0,0,1-2.106-5.017,7.089,7.089,0,0,1,10.463-6.26,7.087,7.087,0,0,1,2.523,2.307l-1.234.768a1.305,1.305,0,0,1-1.718-.256,4.316,4.316,0,0,0-6.123.119,4.556,4.556,0,0,0-1.306,3.317,4.483,4.483,0,0,0,1.348,3.331,4.621,4.621,0,0,0,3.386,1.33,4.093,4.093,0,0,0,2.617-.841,3.16,3.16,0,0,0,1.239-2.111h-3.82a1.091,1.091,0,0,1-1.234-1.234v-1.124Z",
    transform: "translate(-281.137 -287.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M394.251,288.162h1.362a1.1,1.1,0,0,1,1.243,1.234v12.465h-1.371a1.091,1.091,0,0,1-1.234-1.234V296.4h-6.771v5.465h-1.371a1.09,1.09,0,0,1-1.233-1.234V288.162h1.361a1.1,1.1,0,0,1,1.243,1.234v4.679h6.771Z",
    transform: "translate(-288.537 -287.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M415.758,288.162v1.087a1.091,1.091,0,0,1-1.234,1.234h-2.677v10.144a1.091,1.091,0,0,1-1.234,1.234h-1.38V290.483h-3.939V289.4a1.1,1.1,0,0,1,1.243-1.234Z",
    transform: "translate(-294.929 -287.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(903.984 129.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M276.9,314.31v7.9h-1.128v-3.521h-4.536v3.521H270.1v-7.9h1.129v3.4h4.536v-3.4Z",
    transform: "translate(-270.103 -313.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M287.2,322.73a2.861,2.861,0,0,1-1.111-1.089,3.292,3.292,0,0,1,0-3.148,2.824,2.824,0,0,1,1.111-1.083,3.485,3.485,0,0,1,3.2,0,2.831,2.831,0,0,1,1.105,1.083,3.292,3.292,0,0,1,0,3.148,2.868,2.868,0,0,1-1.105,1.089,3.436,3.436,0,0,1-3.2,0Zm2.635-.818a1.875,1.875,0,0,0,.717-.745,2.466,2.466,0,0,0,0-2.2,1.84,1.84,0,0,0-.717-.74,2.184,2.184,0,0,0-2.066,0,1.876,1.876,0,0,0-.722.74,2.415,2.415,0,0,0,0,2.2,1.911,1.911,0,0,0,.722.745,2.149,2.149,0,0,0,2.066,0Z",
    transform: "translate(-274.983 -314.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M303.183,322.137a1.613,1.613,0,0,1-.587.31,2.446,2.446,0,0,1-.722.107,1.918,1.918,0,0,1-1.4-.485,1.852,1.852,0,0,1-.5-1.388V317.4h-1.015v-.89h1.015V315.2h1.084v1.309h1.715v.89h-1.715v3.239a1.048,1.048,0,0,0,.242.745.9.9,0,0,0,.694.26,1.307,1.307,0,0,0,.846-.282Z",
    transform: "translate(-279.137 -314.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M315.131,320.428h-4.852a1.88,1.88,0,0,0,.694,1.269,2.263,2.263,0,0,0,1.473.48,2.217,2.217,0,0,0,1.726-.721l.6.7a2.613,2.613,0,0,1-1.011.722,3.812,3.812,0,0,1-3.029-.141,2.778,2.778,0,0,1-1.134-1.089,3.127,3.127,0,0,1-.4-1.58,3.169,3.169,0,0,1,.389-1.568,2.792,2.792,0,0,1,1.072-1.089,3.053,3.053,0,0,1,1.54-.389,2.991,2.991,0,0,1,1.529.389,2.738,2.738,0,0,1,1.05,1.089,3.315,3.315,0,0,1,.378,1.6A3.072,3.072,0,0,1,315.131,320.428Zm-4.237-2.02a1.914,1.914,0,0,0-.615,1.242h3.837a1.926,1.926,0,0,0-.615-1.236,2.021,2.021,0,0,0-2.607-.006Z",
    transform: "translate(-282.341 -314.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M323.338,313.62h1.084v8.373h-1.084Z",
    transform: "translate(-286.768 -313.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M344.609,322.3l-1.05-1.049a3.644,3.644,0,0,1-2.64,1.015,3.728,3.728,0,0,1-1.422-.259,2.3,2.3,0,0,1-.987-.728,1.717,1.717,0,0,1-.355-1.066,1.994,1.994,0,0,1,.446-1.281,5.141,5.141,0,0,1,1.472-1.146,3.951,3.951,0,0,1-.734-.936,1.877,1.877,0,0,1-.214-.869,1.592,1.592,0,0,1,.581-1.286,2.343,2.343,0,0,1,1.552-.486,2.172,2.172,0,0,1,1.432.44,1.484,1.484,0,0,1,.531,1.207,1.647,1.647,0,0,1-.389,1.072,4.744,4.744,0,0,1-1.292.993l1.951,1.941a5.006,5.006,0,0,0,.486-1.433l.869.283a5.231,5.231,0,0,1-.688,1.805l1.061,1.061Zm-1.693-1.681-2.246-2.234a4.041,4.041,0,0,0-1.133.841,1.336,1.336,0,0,0-.322.874,1.075,1.075,0,0,0,.49.914,2.162,2.162,0,0,0,1.28.35A2.632,2.632,0,0,0,342.916,320.62Zm-2.488-5.354a.884.884,0,0,0-.3.694,1.144,1.144,0,0,0,.164.587,4.371,4.371,0,0,0,.637.768,4.835,4.835,0,0,0,1.078-.756.986.986,0,0,0,.3-.688.791.791,0,0,0-.276-.632,1.153,1.153,0,0,0-.773-.237A1.209,1.209,0,0,0,340.428,315.266Z",
    transform: "translate(-291.406 -313.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M361.649,321.981a3.528,3.528,0,0,1-1.3-.716l.418-.88a3.48,3.48,0,0,0,1.156.66,4.263,4.263,0,0,0,1.451.253,2.608,2.608,0,0,0,1.466-.332,1.027,1.027,0,0,0,.485-.886.872.872,0,0,0-.264-.66,1.776,1.776,0,0,0-.654-.39q-.39-.135-1.1-.3a11.358,11.358,0,0,1-1.439-.429,2.376,2.376,0,0,1-.936-.66,1.762,1.762,0,0,1-.389-1.2,2.032,2.032,0,0,1,.332-1.14,2.287,2.287,0,0,1,1.01-.813,4.091,4.091,0,0,1,1.682-.3,5.356,5.356,0,0,1,1.377.18,3.657,3.657,0,0,1,1.162.519l-.372.9a4.086,4.086,0,0,0-1.061-.479,3.955,3.955,0,0,0-1.105-.164,2.433,2.433,0,0,0-1.439.35,1.07,1.07,0,0,0-.479.9.864.864,0,0,0,.271.66,1.87,1.87,0,0,0,.672.4,10.6,10.6,0,0,0,1.089.3,11.091,11.091,0,0,1,1.433.429,2.417,2.417,0,0,1,.931.655,1.726,1.726,0,0,1,.389,1.185,2.015,2.015,0,0,1-.339,1.134,2.274,2.274,0,0,1-1.027.813,4.248,4.248,0,0,1-1.692.3A5.385,5.385,0,0,1,361.649,321.981Z",
    transform: "translate(-298.352 -313.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M379.38,317.4a2.769,2.769,0,0,1,1.078,1.072,3.175,3.175,0,0,1,.389,1.591,3.207,3.207,0,0,1-.389,1.6,2.747,2.747,0,0,1-1.078,1.078,3.138,3.138,0,0,1-1.557.383,2.769,2.769,0,0,1-1.179-.248,2.444,2.444,0,0,1-.908-.722v3.091h-1.083v-8.169h1.038v.947a2.293,2.293,0,0,1,.914-.75,2.887,2.887,0,0,1,1.218-.253A3.144,3.144,0,0,1,379.38,317.4Zm-.615,4.508a1.906,1.906,0,0,0,.722-.745,2.415,2.415,0,0,0,0-2.2,1.871,1.871,0,0,0-.722-.74,2.051,2.051,0,0,0-1.033-.26,1.991,1.991,0,0,0-1.021.266,1.915,1.915,0,0,0-.723.738,2.2,2.2,0,0,0-.265,1.1,2.275,2.275,0,0,0,.26,1.1,1.856,1.856,0,0,0,.722.745,2.137,2.137,0,0,0,2.06,0Z",
    transform: "translate(-302.831 -314.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M392.925,317.63a2.354,2.354,0,0,1,.66,1.817v3.611h-1.027v-.79a1.707,1.707,0,0,1-.773.637,2.941,2.941,0,0,1-1.19.22,2.492,2.492,0,0,1-1.608-.485,1.668,1.668,0,0,1-.028-2.545,2.839,2.839,0,0,1,1.828-.479H392.5V319.4a1.38,1.38,0,0,0-.406-1.072,1.713,1.713,0,0,0-1.2-.372,3.175,3.175,0,0,0-1.037.174,2.684,2.684,0,0,0-.858.468l-.451-.812a3.26,3.26,0,0,1,1.106-.569,4.614,4.614,0,0,1,1.365-.2A2.7,2.7,0,0,1,392.925,317.63Zm-1.078,4.384a1.575,1.575,0,0,0,.655-.785v-.834h-1.67q-1.377,0-1.377.925a.836.836,0,0,0,.35.711,1.6,1.6,0,0,0,.97.259A2.007,2.007,0,0,0,391.847,322.013Z",
    transform: "translate(-307.129 -314.685)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.5abd142dc840d7af8b3f60ecb32dd305.svg";
export { ForwardRef as ReactComponent };